import Excel from 'exceljs';

function saveFile(filename: string, data: BlobPart[], options?: BlobPropertyBag) {
    const blob = new Blob(data, options)

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.style.display = "none";
    document.body.append(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

type CreationData = {
    creator:string,
    lastModifiedBy?:string,
}

type ExcelColumns = Partial<Excel.Column>[];

type ExcelTableData = {[key:string]:any}[];

function createWorkbook(creationData:CreationData){
    const workbook = new Excel.Workbook();

    workbook.creator = creationData.creator;
    workbook.lastModifiedBy = creationData.creator;
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    return workbook;
}

type CSVData = CreationData & {
    documentName:string,
    columns:ExcelColumns,
    data:ExcelTableData
};

async function exportCSV(csvData:CSVData) {
    const { creator, data, columns, documentName, lastModifiedBy } = csvData;

    const workbook = createWorkbook({creator, lastModifiedBy});

    const worksheet = workbook.addWorksheet(documentName);

    worksheet.columns = columns;

    data.forEach(d=>worksheet.addRow(d))

    const exportData = await workbook.csv.writeBuffer()

    saveFile(documentName, [exportData], {type:"text/csv"});
}

type XLSXData = CreationData & {
    documentName:string,
    columns:ExcelColumns,
    data:ExcelTableData
};

async function exportXLSX(xlsxData:XLSXData){
    const { creator, data, columns, documentName, lastModifiedBy } = xlsxData;

    const workbook = createWorkbook({creator, lastModifiedBy});

    const worksheet = workbook.addWorksheet(documentName);

    worksheet.columns = columns;

    data.forEach(d=>worksheet.addRow(d))

    const exportData = await workbook.xlsx.writeBuffer()

    saveFile(documentName, [exportData], {type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
}

const ExportService = {
    exportCSV,
    exportXLSX
};

export default ExportService;